/**
 * Browser tab session id for audit grouping (same tab = same id until logout / token expiry / new tab).
 * Stored in sessionStorage so a new tab gets a new id; closing the tab clears storage.
 */
const KEY = "auditCorrelationId";

function newCorrelationId(): string {
  const pad2 = (n: number) => String(n).padStart(2, "0");
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = pad2(now.getMonth() + 1);
  const dd = pad2(now.getDate());
  const hh = pad2(now.getHours());
  const mi = pad2(now.getMinutes());
  const ss = pad2(now.getSeconds());

  let suffix = Math.random().toString(36).slice(2, 6);
  try {
    if (typeof crypto !== "undefined" && "getRandomValues" in crypto) {
      const bytes = new Uint32Array(1);
      (crypto as Crypto).getRandomValues(bytes);
      suffix = (bytes[0] >>> 0).toString(36).slice(0, 4).padEnd(4, "0");
    }
  } catch {
    // ignore
  }

  return `sess_${yyyy}${mm}${dd}_${hh}${mi}${ss}_${suffix}`;
}

/** Returns the existing tab session id or creates and persists a new one. */
export function getOrCreateAuditSessionCorrelationId(): string {
  try {
    const existing = sessionStorage.getItem(KEY);
    if (existing) return existing;
    const value = newCorrelationId();
    sessionStorage.setItem(KEY, value);
    return value;
  } catch {
    return newCorrelationId();
  }
}

/** Clears storage and returns a new id (e.g. after logout). */
export function rotateAuditSessionCorrelationId(): string {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
  return getOrCreateAuditSessionCorrelationId();
}
